import {
  SDK_CREDENTIAL_SIGNATURE_STORAGE_KEY,
  SDK_SESSION_STORAGE_KEYS,
} from "../constants/sdk";

export const clearSdkSessionStorage = () => {
  SDK_SESSION_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
};

type SyncSdkCredentialSignatureOptions = {
  rawSignature: string;
  fingerprint: string;
};

export const syncSdkCredentialSignature = ({
  rawSignature,
  fingerprint,
}: SyncSdkCredentialSignatureOptions) => {
  const previousSignature = localStorage.getItem(
    SDK_CREDENTIAL_SIGNATURE_STORAGE_KEY
  );
  const isLegacyRawSignature = Boolean(previousSignature?.includes("|"));

  if (!previousSignature) {
    localStorage.setItem(SDK_CREDENTIAL_SIGNATURE_STORAGE_KEY, fingerprint);
    return;
  }

  const didCredentialsChange = isLegacyRawSignature
    ? previousSignature !== rawSignature
    : previousSignature !== fingerprint;

  if (didCredentialsChange) {
    clearSdkSessionStorage();
  }

  if (isLegacyRawSignature || previousSignature !== fingerprint) {
    localStorage.setItem(SDK_CREDENTIAL_SIGNATURE_STORAGE_KEY, fingerprint);
  }
};
